export default __webpack_public_path__ + "cb443fc9b6740d4366f0384a0d92dcc7.svg";